/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getUserNotificationSettings } from '../fn/user-notification-settings/get-user-notification-settings';
import { GetUserNotificationSettings$Params } from '../fn/user-notification-settings/get-user-notification-settings';
import { updateUserNotificationSettings } from '../fn/user-notification-settings/update-user-notification-settings';
import { UpdateUserNotificationSettings$Params } from '../fn/user-notification-settings/update-user-notification-settings';
import { UserNotificationSettingsResponseDto } from '../models/user-notification-settings-response-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedUserNotificationSettingsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getUserNotificationSettings()` */
  static readonly GetUserNotificationSettingsPath = '/api/users/{id}/notification-settings';

  /**
   * Gets the notification settings of a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserNotificationSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserNotificationSettings$Response(params: GetUserNotificationSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<UserNotificationSettingsResponseDto>> {
    return getUserNotificationSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the notification settings of a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserNotificationSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserNotificationSettings(params: GetUserNotificationSettings$Params, context?: HttpContext): Observable<UserNotificationSettingsResponseDto> {
    return this.getUserNotificationSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserNotificationSettingsResponseDto>): UserNotificationSettingsResponseDto => r.body)
    );
  }

  /** Path part for operation `updateUserNotificationSettings()` */
  static readonly UpdateUserNotificationSettingsPath = '/api/users/{id}/notification-settings';

  /**
   * Changes the notification settings of a user on their behalf.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserNotificationSettings()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateUserNotificationSettings$Response(params: UpdateUserNotificationSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<UserNotificationSettingsResponseDto>> {
    return updateUserNotificationSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * Changes the notification settings of a user on their behalf.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUserNotificationSettings$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateUserNotificationSettings(params: UpdateUserNotificationSettings$Params, context?: HttpContext): Observable<UserNotificationSettingsResponseDto> {
    return this.updateUserNotificationSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserNotificationSettingsResponseDto>): UserNotificationSettingsResponseDto => r.body)
    );
  }

}
